import React, { useState } from "react";
import PropTypes from "prop-types";
import IrisAlertModal from "../components/irisAlertModal/IrisAlertModal";

export default (WrappedComponent) => {
  const HocComponent = ({ ...props }) => {
    const [title, setTitle] = useState("");
    const [message, setMessage] = useState("");

    const openModal = (title, message) => {
      console.log("opening", message, title);
      setTitle(title);
      setMessage(message);
    };

    const closeModal = () => {
      setTitle("");
      setMessage("");
    };

    return (
      <>
        <IrisAlertModal title={title} message={message} onClose={closeModal} />
        <WrappedComponent
          openModal={openModal}
          closeModal={closeModal}
          {...props}
        />
      </>
    );
  };

  HocComponent.propTypes = {};

  return HocComponent;
};
